export const CREDIT_VALUE_CZK = 0.25; // 1 kredit = 0,25 Kč

export const PAY_PER_USE_PRICING = [
  {
    key: 'consultation',
    name: 'Právní konzultace',
    priceCZK: 50,
    credits: 200,
    description: 'AI odpověď na právní dotaz včetně doporučení a odkazů na české právo.'
  },
  {
    key: 'contract-analysis',
    name: 'Analýza smlouvy (do 20 stran)',
    priceCZK: 100,
    credits: 400,
    description: 'Detailní AI rozbor smlouvy s identifikací rizik, doporučeními a kontrolním seznamem.'
  },
  {
    key: 'document-generation',
    name: 'Generování dokumentu',
    priceCZK: 60,
    credits: 240,
    description: 'Profesionální právní dokument s automatickým doplněním údajů a AI kontrolou.'
  }
];

export const SUBSCRIPTION_PLANS = [
  {
    key: 'start',
    name: 'START',
    priceCZK: 499,
    credits: 580,
    usageExamples: ['2–3 konzultace', '1–2 dokumenty', '1 analýza smlouvy'],
    description: 'Ideální pro jednotlivce, kteří potřebují právní pomoc několikrát do měsíce.',
    userLabel: 'Pro 1 uživatele'
  },
  {
    key: 'standard',
    name: 'STANDARD',
    tagline: '⭐ Nejoblíbenější',
    priceCZK: 1_299,
    credits: 1_600,
    usageExamples: ['6 konzultací', '4 dokumenty', '2 analýzy smluv'],
    description: 'Pro menší kanceláře nebo podnikatele.',
    userLabel: 'Pro 2 uživatele'
  },
  {
    key: 'pro',
    name: 'PRO',
    priceCZK: 3_299,
    credits: 4_300,
    usageExamples: ['15 konzultací', '10 dokumentů', '7 analýz smluv'],
    description: 'Pro týmy a firmy, které právní služby využívají intenzivně.',
    userLabel: 'Pro 5 uživatelů'
  },
  {
    key: 'custom',
    name: 'CUSTOM',
    tagline: 'Plně na míru',
    priceLabel: 'Na vyžádání',
    creditsLabel: 'Dle potřeby',
    usageExamples: [
      'Kreditní rámec podle vašich procesů',
      'Počet uživatelů nastavíme dle týmu',
      'VIP podpora a SLA na míru'
    ],
    description: 'Připravíme tarif podle potřeb vaší firmy po konzultaci s naší obchodní ředitelkou.',
    userLabel: 'Pro libovolný tým',
    isCustom: true
  }
];

export const EXTRA_CREDIT_PRICE_CZK = 9; // cena za 1 kredit při dokoupení
